import { FormLabel, Select } from "@oysterhr/ui"
import { Controller, useFormContext } from "react-hook-form"
import { AvailablePaySupplementLabels } from "../constants"
import { useTranslation } from "react-i18next"
import { useMemo } from "react"
import { PayrollChangeFormValues } from "../types"

export const PaymentTypeSelect = () => {
  const { t } = useTranslation(["Payroll", "PaySupplements"])
  const { control } = useFormContext<PayrollChangeFormValues>()
  const paymentTypeOptions = useMemo(
    () =>
      Object.entries(AvailablePaySupplementLabels)
        .map(([value, translationKey]) => ({
          value,
          label: t(translationKey, { ns: "PaySupplements" }),
        }))
        .sort(({ label: a }, { label: b }) => a.localeCompare(b)),
    [t],
  )

  return (
    <Controller
      name="paymentType"
      control={control}
      render={({ field: { ref: _ref, ...field }, fieldState: { error } }) => (
        <Select
          label={<FormLabel label={t("form.label.paymentType")} htmlFor={field.name} />}
          error={error?.message}
          placeholder={t("form.placeholders.paymentType")}
          {...field}
        >
          {paymentTypeOptions.map(({ label, value }) => (
            <Select.Option key={value} value={value}>
              {label}
            </Select.Option>
          ))}
        </Select>
      )}
    />
  )
}
